import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose, branch, renderComponent, mapProps } from 'recompose';

import { isLoading, isLogin, myRoles, isFirstTimeLogin } from '../Redux/user-profile/selectors';
import withTracker from '../Containers/HOC/withTracker';
import { RobotLoading } from '../Components/Loading';

const CannotAccess = () => <div>You do not have permission to access this page</div>;

const redirectLoginHoc = branch(
  props => !props.isLogin,
  renderComponent(
    mapProps(props => ({
      to: {
        pathname: '/login',
        state: { from: props.location },
      },
    }))(Redirect),
  ),
);

const redirectFillInformation = branch(
  props => props.isFirstTimeLogin && props.location.pathname !== '/register/profile',
  renderComponent(
    mapProps(props => ({
      to: {
        pathname: '/register/profile',
        state: { from: props.location },
      },
    }))(Redirect),
  ),
);

const notAccessHoc = (roles = []) =>
  branch(
    ({ isLogin, myRoles }) =>
      isLogin && roles && roles.length > 0 && !roles.some(role => myRoles.indexOf(role) >= 0),
    renderComponent(CannotAccess),
  );

const AuthenHOC = (enabledRoles = []) =>
  compose(
    connect(state => ({
      isLoading: isLoading(state),
      isLogin: isLogin(state),
      myRoles: myRoles(state),
      isFirstTimeLogin: isFirstTimeLogin(state),
    })),
    branch(props => props.isLoading, renderComponent(RobotLoading)),
    redirectLoginHoc,
    redirectFillInformation,
    notAccessHoc(enabledRoles),
  );

export const PrivateRoute = ({ component: Component, roles, menus, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const AuthComp = AuthenHOC(roles)(Component);
      return <AuthComp {...props} menus={menus} />;
    }}
  />
);

const GenRoute = ({ menus, ...restProps }) => {
  return menus.map(menu => {
    if (!menu.route) {
      return null;
    }
    return menu.private ? (
      <PrivateRoute
        key={'route' + menu.path}
        path={menu.path}
        exact={menu.exact}
        component={withTracker(menu.route)}
        componentProps={restProps}
        roles={menu.roles}
        menus={menus}
      />
    ) : (
      <PublicRoute
        key={'route' + menu.path}
        path={menu.path}
        exact
        component={withTracker(menu.route)}
        componentProps={restProps}
        menus={menus}
      />
    );
  });
};

const GenSwitchRoute = ({ menus, ...restProps }) => (
  <Switch>
    {menus.map(menu => {
      if (!menu.route) {
        return null;
      }
      return menu.private ? (
        <PrivateRoute
          key={'route' + menu.path}
          path={menu.path}
          exact={menu.exact}
          component={withTracker(menu.route)}
          roles={menu.roles}
          componentProps={restProps}
          menus={menus}
        />
      ) : (
        <PublicRoute
          key={'route' + menu.path}
          path={menu.path}
          exact
          component={withTracker(menu.route)}
          componentProps={restProps}
          menus={menus}
        />
      );
    })}
  </Switch>
);

export const PublicRoute = Route;

export { GenRoute, GenSwitchRoute };

export default { PrivateRoute, PublicRoute };
